import { useMutationEditReportTemplate } from 'api/mutations/editReportTemplate.mutation';
import { useQueryGetReportsTags } from 'api/queries/getReportsTags.query';

export type UseEditReportTemplateModalProvider = ReturnType<typeof useEditReportTemplateModalProvider>;

export const useEditReportTemplateModalProvider = () => {
    const reportTemplateEditMutation = useMutationEditReportTemplate();
    const getReportTags = useQueryGetReportsTags();

    return {
        api: {
            getAllReportsTags: getReportTags,
            editReportTemplate: {
                instance: reportTemplateEditMutation,
            },
        },
    };
};
